import { ClockIcon } from '@heroicons/react/24/solid'

import { formatRequestDate } from '../RequestDetails/Content/lib/utils'

type Props = {
  dateStart: string
  dateEnd: string
  hideTodayLabel?: boolean
}

export const PassDateRange = ({
  dateStart,
  dateEnd,
  hideTodayLabel
}: Props) => (
  <div className="flex items-center gap-8">
    <div className="w-20 text-grey-40">
      <ClockIcon />
    </div>
    <span className="text-grey-80 text-16 sm:text-14">
      {formatRequestDate(dateStart, hideTodayLabel)} -{' '}
      {formatRequestDate(dateEnd, hideTodayLabel)}
    </span>
  </div>
)
